module.exports = __webpack_public_path__ + "img/6861c19444fb91e63e2cd0d31c9350b2.55a9d583.webp";